import { useMemo } from 'react';
import { useAuthStore } from 'processes/auth/model/state';
import { ExtensionsEnum } from 'entities/Extensions/enums';
import { FeaturesEnum } from 'entities/Company/types';
import { extensionsArray } from 'widgets/Extensions/ExtensionsToSelect/consts/all_extensions';

export function useExtension() {
	const { company } = useAuthStore();

	const extensionsList = useMemo(() => {
		const inboundEmail = company?.additionalFeatures?.find(
			(item) => item.feature === FeaturesEnum.INBOUND_EMAIL,
		)?.isEnabled;

		return extensionsArray
			.map((exItem) => {
				const selectedExtension = company?.extensions?.find(
					(userExItem) => userExItem.extension === exItem.extension,
				);
				return selectedExtension ? { ...exItem, isSelected: true } : exItem;
			})
			.filter((item) => (item.extension === ExtensionsEnum.inbound_email ? inboundEmail : true));
	}, [company]);

	const addedExtensions = useMemo(
		() =>
			company?.extensions?.map((userExItem) => {
				const selectedExtension = extensionsArray.find(
					(exItem) => exItem.extension === userExItem.extension,
				);
				return {
					...userExItem,
					title: selectedExtension?.title || '',
					tableDescription: selectedExtension?.tableDescription || '',
				};
			}),
		[company],
	);

	const getExtension = (exName: ExtensionsEnum) =>
		company?.extensions?.find((item) => item.extension === exName);

	return { extensionsList, addedExtensions, getExtension };
}
